import { useMemo } from 'react'
import { useHomePlacementSearchQuery } from 'domains/banners/api'

export const useContentBannerSearch = () => {
  const { data, error, loading, refetch } = useHomePlacementSearchQuery({
    fetchPolicy: 'cache-and-network',
    variables: {},
  })

  const banners = useMemo(() => data?.homePlacementSearch || [], [data])

  return {
    banners,
    searchBanners: refetch,
    apiResult: data?.homePlacementSearch,
    apiSuccess: Boolean(data),
    apiLoading: loading,
    apiError: error,
  }
}
